import { throttle } from '@tanstack/react-pacer';

import { IViewerStoreInjector, appContainer } from '../../../inversify.config';
import { TYPES } from '../../../inversify.types';
import { arrowRightShortcut } from './arrow-right';

const THROTTLED_WAIT_TIME_IN_MS = 1000;

export const wheelDownShortcut = {
  key: new Set(['WheelDown']),
  callBackFunction: throttle(
    () => {
      const { pageMode } = appContainer.get<IViewerStoreInjector>(TYPES.Store.Viewer).getState();
      const isSinglePageMode = pageMode === 'single';

      if (!isSinglePageMode) return;

      //? prev page
      arrowRightShortcut.callBackFunction();
    },
    { wait: THROTTLED_WAIT_TIME_IN_MS, trailing: false }
  ),
};
